@use '@/sass/variables';

.issuesContainer {
  max-height: 60vh;
}

.alertIcon {
  flex-shrink: 0;
}

.issueCard {
  background-color: variables.$near-white;
  border-radius: variables.$border-radius-2;
  margin-bottom: variables.$spacing-medium;
  padding: variables.$spacing-medium;
}

.issueContent {
  flex: 1;
}

.issueTitle {
  font-weight: 600;
  margin-bottom: variables.$spacing-small;
  color: variables.$near-black;
}

.issueDescription {
  margin-bottom: variables.$spacing-medium;
  color: variables.$dark-gray;
  line-height: 1.5;
}

.affectedDefinitions {
  margin-bottom: variables.$spacing-medium;
  padding: variables.$spacing-small;
  background-color: variables.$white;
  border-radius: variables.$border-radius-1;
  border: 1px solid variables.$light-gray;
  font-size: variables.$font-size-6;
  color: variables.$dark-gray;
}
